import { FC } from 'react';
import ReactSelect, { ActionMeta, ClassNamesConfig, MultiValue, SingleValue, StylesConfig } from 'react-select';
import classNames from '../../utils/classnames';

export type SingleSelect = {
    label: string;
    value: string;
};

type SelectProps = {
    name: string;
    onChange: (
        newValue: SingleValue<SingleSelect> | MultiValue<SingleSelect>,
        actionMeta: ActionMeta<SingleSelect>
    ) => void;
    options: SingleSelect[];
    placeholder?: string;
    value: SingleValue<SingleSelect> | MultiValue<SingleSelect> | null;
    className?: string;
    classNames?: ClassNamesConfig<SingleSelect, boolean>;
    customStyle?: StylesConfig<SingleSelect, boolean> | undefined;
    defaultValue?: SingleValue<SingleSelect> | MultiValue<SingleSelect>;
    hasError?: boolean;
    id?: string;
    isMulti?: boolean;
};

export const formatStringForSelect = (data: string): SingleSelect => ({
    label: data,
    value: data
});

export const formatArrayForSelect = (data: string[] = []): SingleSelect[] =>
    data.map((item) => ({
        label: item,
        value: item
    }));

export const formatResponseForSelect = (data: object[], labelKey: string, valueKey: string): SingleSelect[] =>
    data.map((item) => ({ label: item[labelKey], value: item[valueKey] }));

const Select: FC<SelectProps> = ({
    name,
    id,
    isMulti,
    defaultValue,
    onChange,
    options,
    placeholder,
    hasError = false,
    value,
    customStyle,
    classNames: selectClassNames,
    className = ''
}) => (
    // @ts-ignore
    <ReactSelect
        className={classNames(`${className}`, { 'error-field': hasError })}
        classNames={selectClassNames}
        defaultValue={defaultValue}
        id={id}
        isMulti={isMulti}
        name={name}
        options={options}
        placeholder={placeholder}
        styles={customStyle}
        theme={(theme) => ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#26BFBF'
            }
        })}
        value={value}
        onChange={onChange}
    />
);

export default Select;
